module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/link-640x320-08e6625b0ac2c0be081926b38bb839af.webp";